module.exports = __webpack_public_path__ + "media/images/flags/32/Guam-507853d2a85c76ec6e60752d4ccf949a.png";